import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Heading1, Heading2 } from '@blueprint/heading';
import { ButtonLink } from '@blueprint/ui';
import { ButtonLinkWithIcon } from '@blueprint/ui';
import { Text } from '@blueprint/text';

export const Container = styled('section')(
    ({ theme: { spacing, mq, colors } }) => css`
        margin-bottom: ${spacing['32px']};

        ${ButtonLinkWithIcon} {
            padding-left: 0;
        }

        ${Heading1}, ${Heading2} {
            margin-top: ${spacing['16px']};
            margin-bottom: ${spacing['16px']};
        }

        ${mq.large} {
            border-bottom: 1px solid ${colors['graphic-divider']};
            padding-bottom: ${spacing['32px']};
        }

        ${mq.small} {
            ${Heading1} {
                margin-top: ${spacing['16px']};
                margin-bottom: ${spacing['16px']};
            }
        }
    `
);

export const LocationDetails = styled('div')(
    ({ theme: { mq, spacing } }) => css`
        display: block;

        ${mq.small} {
            display: flex;

            ${Text} {
                align-self: center;
                margin-right: ${spacing['16px']};
            }
        }
    `
);

export const SideLinkWrapper = styled('div')(
    ({ theme: { spacing, mq, colors } }) => css`
        padding: ${spacing['24px']} 0;

        ${ButtonLinkWithIcon},
        ${Button} {
            padding: 0;
            margin-left: 0;
            text-align: left;
        }

        ${mq.small} {
            padding: 0;
            display: flex;
            margin-left: ${spacing['16px']};
            border-left: 1px solid ${colors['graphic-divider']};

            ${ButtonLinkWithIcon},
            ${Button},
            ${Text} {
                padding-left: ${spacing['24px']};
            }
        }
    `
);

export const PriceDetails = styled('div')(
    ({ theme: { mq, spacing } }) => css`
        margin-top: ${spacing['16px']};

        ${Button} {
            margin-top: 0;
        }

        ${mq.small} {
            display: flex;
            align-items: center;

            ${Text} {
                padding-right: ${spacing['24px']};
                margin: 0;
                padding-bottom: ${spacing['8px']};
                padding-top: ${spacing['8px']};
            }

            ${ButtonLinkWithIcon} {
                padding-left: ${spacing['24px']};
            }
        }
    `
);

export const Button = styled(ButtonLink)(
    ({ theme: { mq, spacing } }) => css`
        margin-top: ${spacing['16px']};
        ${mq.small} {
            width: unset;
        }
    `
);
